<template>
	<a href="javascript:void(0)" v-on:click="addBookmark(data.user_id, data.post_id)" style="padding-left: 0;">
	    <i v-bind:class="[bookmarkStatus ? 'fa fa-bookmark' : 'fa fa-bookmark-o']"></i> Bookmark
	</a>
</template>

<script>
	export default {
        props: ['data'],
        data() {
        	return {
        		bookmarkStatus: this.data.bookmark,
        	};
        },
    	methods: {
        	addBookmark(user_id, post_id) {
	    		event.preventDefault();
	    		const form = new FormData();
	    		form.append('user_id', user_id);                                  		
	    		form.append('post_id', post_id);                          
	    		axios.post('/api/ajax/posts/bookmark/update', form).then(res => {
	    			this.bookmarkStatus = !this.bookmarkStatus;
			    });
        	},
    	},               	
	}
</script>
